import axios from "axios";

import { getToken } from "@/utils/tokenStorage";

const API = "/api";

// `getToken` em vez de localStorage.getItem("token"), que era o que a versao
// antiga desta tela fazia. A chave canonica e' `${slug}:token`; a legada `token`
// so' continua funcionando porque `saveToken` a mantem sincronizada, e ela e'
// compartilhada entre tenants. Ler direto do localStorage aposta nesse resquicio
// de compatibilidade — `getToken` tenta a chave do tenant atual primeiro.
const headers = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export async function carregarPrograma() {
  const h = headers();
  const [codigo, resumo, indicados] = await Promise.all([
    axios.get(`${API}/referral/my-code`, { headers: h }),
    axios.get(`${API}/referral/my-summary`, { headers: h }),
    axios.get(`${API}/referral/my-referrals`, { headers: h }),
  ]);
  return {
    code: codigo.data?.code || "",
    link: codigo.data?.link || "",
    resumo: resumo.data || {},
    indicados: indicados.data?.referrals || [],
  };
}
